import { z } from 'zod';
import {
  posPoCarrierRowSchema,
  posPoSupplierRowSchema,
  posPurchaseOrderListResponseSchema,
} from './purchase-orders';

/** Catalogue lists use the same paginatedResponse envelope (including pg COUNT strings). */
export function posCatalogRegistryListDataSchema<T extends z.ZodType>(rowSchema: T) {
  return z.object({
    items: z.array(rowSchema),
    pagination: posPurchaseOrderListResponseSchema.shape.data.shape.pagination,
  });
}
export type PosCatalogRegistryListData<T> = z.infer<
  ReturnType<typeof posCatalogRegistryListDataSchema<z.ZodType<T>>>
>;
export const posSupplierRegistryListDataSchema = posCatalogRegistryListDataSchema(posPoSupplierRowSchema);
export type PosSupplierRegistryListData = z.infer<typeof posSupplierRegistryListDataSchema>;
export const posCarrierRegistryListDataSchema = posCatalogRegistryListDataSchema(posPoCarrierRowSchema);
export type PosCarrierRegistryListData = z.infer<typeof posCarrierRegistryListDataSchema>;

/**
 * POST/PUT suppliers return INSERT/UPDATE RETURNING *, unlike GET which adds
 * the computed is_locked governance alias. All actual fiscal columns retain
 * their canonical nullable wire types (fiscal_code, pec, zip, sdi_code, etc.).
 */
export const posSupplierSavedRowSchema = posPoSupplierRowSchema.omit({ is_locked: true });
export type PosSupplierSavedRow = z.infer<typeof posSupplierSavedRowSchema>;